function initHlaBars() {
  document.querySelectorAll('.hla').forEach(function (bar) {
    if (bar.dataset.hlaInit) return;
    bar.dataset.hlaInit = 'true';

    var storageKey = 'hla_dismissed_' + bar.id;
    var dismissDays = parseInt(bar.dataset.dismissDays, 10) || 3;
    var dismissedAt = window.localStorage.getItem(storageKey);
    if (dismissedAt) {
      var elapsedDays = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
      if (elapsedDays < dismissDays) {
        bar.style.display = 'none';
        return;
      }
    }

    var slides = Array.from(bar.querySelectorAll('.hla__slide'));
    var speed = parseInt(bar.dataset.speed, 10) || 4000;
    var current = 0;

    if (slides.length > 1) {
      window.setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, speed);
    }

    var closeBtn = bar.querySelector('[data-hla-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        window.localStorage.setItem(storageKey, Date.now().toString());
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', initHlaBars);
document.addEventListener('shopify:section:load', initHlaBars);
